/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToApiResponse, convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminAssignProductToGroupSale,
    AdminAssignProductToGroupSaleFromJSON,
    AdminAssignProductToGroupSaleToJSON,
    AdminCategoryListResp,
    AdminCategoryListRespFromJSON,
    AdminCategoryListRespToJSON,
    AdminCreateProduct,
    AdminCreateProductFromJSON,
    AdminCreateProductToJSON,
    AdminDownloadListImages,
    AdminDownloadListImagesFromJSON,
    AdminDownloadListImagesToJSON,
    AdminPrintLabelRequest,
    AdminPrintLabelRequestFromJSON,
    AdminPrintLabelRequestToJSON,
    AdminPrintLabelResponse,
    AdminPrintLabelResponseFromJSON,
    AdminPrintLabelResponseToJSON,
    AdminProductConsistencyDescriptionsResp,
    AdminProductConsistencyDescriptionsRespFromJSON,
    AdminProductConsistencyDescriptionsRespToJSON,
    AdminProductCreateResp,
    AdminProductCreateRespFromJSON,
    AdminProductCreateRespToJSON,
    AdminProductDetail,
    AdminProductDetailFromJSON,
    AdminProductDetailToJSON,
    AdminProductDetailImage,
    AdminProductDetailImageFromJSON,
    AdminProductDetailImageToJSON,
    AdminProductListResp,
    AdminProductListRespFromJSON,
    AdminProductListRespToJSON,
    AdminRotateImageReq,
    AdminRotateImageReqFromJSON,
    AdminRotateImageReqToJSON,
    AdminUpdateProduct,
    AdminUpdateProductFromJSON,
    AdminUpdateProductToJSON,
    AdminUpdateProductsStatus,
    AdminUpdateProductsStatusFromJSON,
    AdminUpdateProductsStatusToJSON,
} from '../models';

export interface ProductsApiDeleteAdminDeleteImageRequest {
    productId: string;
    imageId: number;
}

export interface ProductsApiGetAdminDownloadProductImagesRequest {
    params: AdminDownloadListImages;
}

export interface ProductsApiGetAdminProductDetailRequest {
    id: string;
}

export interface ProductsApiGetAdminProductDownloadImageRequest {
    id: string;
    imageId: number;
}

export interface ProductsApiPostAdminAssignProductsToGroupSaleRequest {
    params: AdminAssignProductToGroupSale;
}

export interface ProductsApiPostAdminAttachImagesRequest {
    id: string;
    images?: Array<Blob>;
}

export interface ProductsApiPostAdminPrintLabelRequest {
    params: AdminPrintLabelRequest;
}

export interface ProductsApiPostAdminProductCreateRequest {
    params: AdminCreateProduct;
}

export interface ProductsApiPostAdminProductListRequest {
    brokenLink?: boolean;
    categoryIDs?: Array<number>;
    consistency?: Array<PostAdminProductListConsistencyEnum>;
    consistencyDetails?: Array<string>;
    duplicates?: boolean;
    groupSaleIDs?: Array<string>;
    limit?: number;
    marketplace?: Array<PostAdminProductListMarketplaceEnum>;
    offset?: number;
    palletOrderIDs?: Array<number>;
    search?: string;
    showSold?: boolean;
    status?: Array<PostAdminProductListStatusEnum>;
}

export interface ProductsApiPostAdminRotateImageRequest {
    id: string;
    imageId: number;
    params: AdminRotateImageReq;
}

export interface ProductsApiPostAdminUpdateProductsStatusRequest {
    params: AdminUpdateProductsStatus;
}

export interface ProductsApiPutAdminProductUpdateRequest {
    id: string;
    params: AdminUpdateProduct;
}

export function createDeleteAdminDeleteImagePath(productId: string, imageId: string): string {
    return `/admin/products/{product_id}/images/{image_id}`
        .replace(`{${'product_id'}}`, encodeURIComponent(productId))
        .replace(`{${'image_id'}}`, encodeURIComponent(imageId));
}
export function createDeleteAdminDeleteImageFullPath(productId: string, imageId: string): string {
    return (
        runtime.BASE_PATH +
        `/admin/products/{product_id}/images/{image_id}`
            .replace(`{${'product_id'}}`, encodeURIComponent(productId))
            .replace(`{${'image_id'}}`, encodeURIComponent(imageId))
    );
}
export function createGetAdminDownloadProductImagesPath(): string {
    return `/admin/products/images/download-batch`;
}
export function createGetAdminDownloadProductImagesFullPath(): string {
    return runtime.BASE_PATH + `/admin/products/images/download-batch`;
}
export function createGetAdminProductCategoryListPath(): string {
    return `/admin/product_categories`;
}
export function createGetAdminProductCategoryListFullPath(): string {
    return runtime.BASE_PATH + `/admin/product_categories`;
}
export function createGetAdminProductDetailPath(id: string): string {
    return `/admin/products/{id}`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createGetAdminProductDetailFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/products/{id}`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createGetAdminProductDownloadImagePath(id: string, imageId: string): string {
    return `/admin/products/{id}/images/{image_id}`
        .replace(`{${'id'}}`, encodeURIComponent(id))
        .replace(`{${'image_id'}}`, encodeURIComponent(imageId));
}
export function createGetAdminProductDownloadImageFullPath(id: string, imageId: string): string {
    return (
        runtime.BASE_PATH +
        `/admin/products/{id}/images/{image_id}`
            .replace(`{${'id'}}`, encodeURIComponent(id))
            .replace(`{${'image_id'}}`, encodeURIComponent(imageId))
    );
}
export function createGetAdminProductsConsistencyDetailsPath(): string {
    return `/admin/products/consistency-details`;
}
export function createGetAdminProductsConsistencyDetailsFullPath(): string {
    return runtime.BASE_PATH + `/admin/products/consistency-details`;
}
export function createPostAdminAssignProductsToGroupSalePath(): string {
    return `/admin/products/assign-to-group-sale`;
}
export function createPostAdminAssignProductsToGroupSaleFullPath(): string {
    return runtime.BASE_PATH + `/admin/products/assign-to-group-sale`;
}
export function createPostAdminAttachImagesPath(id: string): string {
    return `/admin/products/{id}/images`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createPostAdminAttachImagesFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/products/{id}/images`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createPostAdminPrintLabelPath(): string {
    return `/admin/products/print-labels`;
}
export function createPostAdminPrintLabelFullPath(): string {
    return runtime.BASE_PATH + `/admin/products/print-labels`;
}
export function createPostAdminProductCreatePath(): string {
    return `/admin/products`;
}
export function createPostAdminProductCreateFullPath(): string {
    return runtime.BASE_PATH + `/admin/products`;
}
export function createPostAdminProductListPath(): string {
    return `/admin/products`;
}
export function createPostAdminProductListFullPath(): string {
    return runtime.BASE_PATH + `/admin/products`;
}
export function createPostAdminRotateImagePath(id: string, imageId: string): string {
    return `/admin/products/{id}/images/{image_id}/rotate`
        .replace(`{${'id'}}`, encodeURIComponent(id))
        .replace(`{${'image_id'}}`, encodeURIComponent(imageId));
}
export function createPostAdminRotateImageFullPath(id: string, imageId: string): string {
    return (
        runtime.BASE_PATH +
        `/admin/products/{id}/images/{image_id}/rotate`
            .replace(`{${'id'}}`, encodeURIComponent(id))
            .replace(`{${'image_id'}}`, encodeURIComponent(imageId))
    );
}
export function createPostAdminUpdateProductsStatusPath(): string {
    return `/admin/products/update-status`;
}
export function createPostAdminUpdateProductsStatusFullPath(): string {
    return runtime.BASE_PATH + `/admin/products/update-status`;
}
export function createPutAdminProductUpdatePath(id: string): string {
    return `/admin/products/{id}`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createPutAdminProductUpdateFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/products/{id}`.replace(`{${'id'}}`, encodeURIComponent(id));
}

/**
 *
 */
export class ProductsApi extends runtime.BaseAPI {
    /**
     * Delete image
     * Delete image
     */
    async deleteAdminDeleteImage(
        requestParameters: ProductsApiDeleteAdminDeleteImageRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.productId === null || requestParameters?.productId === undefined) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter requestParameters.productId was null or undefined when calling deleteAdminDeleteImage.'
            );
        }

        if (requestParameters?.imageId === null || requestParameters?.imageId === undefined) {
            throw new runtime.RequiredError(
                'imageId',
                'Required parameter requestParameters.imageId was null or undefined when calling deleteAdminDeleteImage.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createDeleteAdminDeleteImagePath(
                        String(requestParameters?.productId),
                        String(requestParameters?.imageId)
                    ),
                    method: 'DELETE',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
    /**
     * Download product images
     * Download product images
     */
    async getAdminDownloadProductImages(
        requestParameters: ProductsApiGetAdminDownloadProductImagesRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<Blob>> {
        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling getAdminDownloadProductImages.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createGetAdminDownloadProductImagesPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminDownloadListImagesToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.BlobApiResponse(response));
    }
    /**
     * Get product category list
     * Get product category list
     */
    async getAdminProductCategoryList(
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminCategoryListResp>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createGetAdminProductCategoryListPath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminCategoryListRespFromJSON(jsonValue))
        );
    }
    /**
     * Get product detail
     * Get product detail
     */
    async getAdminProductDetail(
        requestParameters: ProductsApiGetAdminProductDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminProductDetail>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling getAdminProductDetail.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createGetAdminProductDetailPath(String(requestParameters?.id)),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminProductDetailFromJSON(jsonValue))
        );
    }
    /**
     * Download image
     * Download image
     */
    async getAdminProductDownloadImage(
        requestParameters: ProductsApiGetAdminProductDownloadImageRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<Blob>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling getAdminProductDownloadImage.'
            );
        }

        if (requestParameters?.imageId === null || requestParameters?.imageId === undefined) {
            throw new runtime.RequiredError(
                'imageId',
                'Required parameter requestParameters.imageId was null or undefined when calling getAdminProductDownloadImage.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createGetAdminProductDownloadImagePath(
                        String(requestParameters?.id),
                        String(requestParameters?.imageId)
                    ),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.BlobApiResponse(response));
    }
    /**
     * Get products consistency details
     * Get products consistency details
     */
    async getAdminProductsConsistencyDetails(
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminProductConsistencyDescriptionsResp>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createGetAdminProductsConsistencyDetailsPath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) =>
                      AdminProductConsistencyDescriptionsRespFromJSON(jsonValue)
                  )
        );
    }
    /**
     * Assign products to group sale
     * Assign products to group sale
     */
    async postAdminAssignProductsToGroupSale(
        requestParameters: ProductsApiPostAdminAssignProductsToGroupSaleRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling postAdminAssignProductsToGroupSale.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createPostAdminAssignProductsToGroupSalePath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminAssignProductToGroupSaleToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
    /**
     * Attach images to product
     * Attach images to product
     */
    async postAdminAttachImages(
        requestParameters: ProductsApiPostAdminAttachImagesRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling postAdminAttachImages.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        const consumes: runtime.Consume[] = [{contentType: 'multipart/form-data'}];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: {append(param: string, value: any): any};
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters?.images) {
            requestParameters.images.forEach((element) => {
                formParams.append('images', element as any);
            });
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createPostAdminAttachImagesPath(String(requestParameters?.id)),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: formParams,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
    /**
     * Print product labels
     * Print product labels
     */
    async postAdminPrintLabel(
        requestParameters: ProductsApiPostAdminPrintLabelRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminPrintLabelResponse>> {
        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling postAdminPrintLabel.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createPostAdminPrintLabelPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminPrintLabelRequestToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminPrintLabelResponseFromJSON(jsonValue))
        );
    }
    /**
     * Create product
     * Create product
     */
    async postAdminProductCreate(
        requestParameters: ProductsApiPostAdminProductCreateRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminProductCreateResp>> {
        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling postAdminProductCreate.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createPostAdminProductCreatePath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminCreateProductToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminProductCreateRespFromJSON(jsonValue))
        );
    }
    /**
     * Get product list
     * Get product list
     */
    async postAdminProductList(
        requestParameters?: ProductsApiPostAdminProductListRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminProductListResp>> {
        const queryParameters: any = {};

        if (requestParameters?.brokenLink !== undefined) {
            queryParameters['brokenLink'] = requestParameters.brokenLink;
        }

        if (requestParameters?.categoryIDs) {
            queryParameters['categoryIDs'] = requestParameters.categoryIDs;
        }

        if (requestParameters?.consistency) {
            queryParameters['consistency'] = requestParameters.consistency;
        }

        if (requestParameters?.consistencyDetails) {
            queryParameters['consistencyDetails'] = requestParameters.consistencyDetails;
        }

        if (requestParameters?.duplicates !== undefined) {
            queryParameters['duplicates'] = requestParameters.duplicates;
        }

        if (requestParameters?.groupSaleIDs) {
            queryParameters['groupSaleIDs'] = requestParameters.groupSaleIDs;
        }

        if (requestParameters?.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters?.marketplace) {
            queryParameters['marketplace'] = requestParameters.marketplace;
        }

        if (requestParameters?.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters?.palletOrderIDs) {
            queryParameters['palletOrderIDs'] = requestParameters.palletOrderIDs;
        }

        if (requestParameters?.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters?.showSold !== undefined) {
            queryParameters['showSold'] = requestParameters.showSold;
        }

        if (requestParameters?.status) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createPostAdminProductListPath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminProductListRespFromJSON(jsonValue))
        );
    }
    /**
     * Rotate every size of a product image by 90 degrees clockwise or counterclockwise. The image gets new file paths.
     * Rotate image
     */
    async postAdminRotateImage(
        requestParameters: ProductsApiPostAdminRotateImageRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminProductDetailImage>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling postAdminRotateImage.'
            );
        }

        if (requestParameters?.imageId === null || requestParameters?.imageId === undefined) {
            throw new runtime.RequiredError(
                'imageId',
                'Required parameter requestParameters.imageId was null or undefined when calling postAdminRotateImage.'
            );
        }

        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling postAdminRotateImage.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createPostAdminRotateImagePath(
                        String(requestParameters?.id),
                        String(requestParameters?.imageId)
                    ),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminRotateImageReqToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminProductDetailImageFromJSON(jsonValue))
        );
    }
    /**
     * Set one status on the selected products
     * Change status of products
     */
    async postAdminUpdateProductsStatus(
        requestParameters: ProductsApiPostAdminUpdateProductsStatusRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling postAdminUpdateProductsStatus.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createPostAdminUpdateProductsStatusPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminUpdateProductsStatusToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
    /**
     * Update product
     * Update product
     */
    async putAdminProductUpdate(
        requestParameters: ProductsApiPutAdminProductUpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling putAdminProductUpdate.'
            );
        }

        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling putAdminProductUpdate.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createPutAdminProductUpdatePath(String(requestParameters?.id)),
                    method: 'PUT',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminUpdateProductToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
}

/**
 * @export
 */
export const PostAdminProductListConsistencyEnum = {
    new: 'new',
    used: 'used',
    like_new: 'like_new',
} as const;
export type PostAdminProductListConsistencyEnum =
    (typeof PostAdminProductListConsistencyEnum)[keyof typeof PostAdminProductListConsistencyEnum];
/**
 * @export
 */
export const PostAdminProductListMarketplaceEnum = {
    facebook: 'facebook',
    ebay: 'ebay',
    offer_up: 'offer_up',
    craigs_list: 'craigs_list',
    mercari: 'mercari',
    poshmark: 'poshmark',
    walmart: 'walmart',
    depop: 'depop',
} as const;
export type PostAdminProductListMarketplaceEnum =
    (typeof PostAdminProductListMarketplaceEnum)[keyof typeof PostAdminProductListMarketplaceEnum];
/**
 * @export
 */
export const PostAdminProductListStatusEnum = {
    draft: 'draft',
    ready_for_sale: 'ready_for_sale',
    active: 'active',
    reserved: 'reserved',
    sold: 'sold',
    took_for_themself: 'took_for_themself',
    need_review: 'need_review',
} as const;
export type PostAdminProductListStatusEnum =
    (typeof PostAdminProductListStatusEnum)[keyof typeof PostAdminProductListStatusEnum];
